export const ZillowLogo = ({ height = 24 }: { height?: number }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      fill="none"
      viewBox="0 0 24 20"
      //   role="presentation"
    >
      <title>Zillow</title>
      <g>
        <path
          d="M14.29 7.345c.3-.067.614.049.795.297l1.11 1.508a.774.774 0 0 1-.167 1.085c-2.277 1.674-4.744 3.9-6.163 5.526-.034.038-.009.044.014.035 2.525-.935 8.329-2.315 11.124-2.702V9.608l.003.002c0-.456-.21-.894-.57-1.18l-.185-.148-8.807-6.96a1.507 1.507 0 0 0-1.865 0S3.158 6.387.57 8.43C.21 8.716 0 9.15 0 9.609v2.84C6.255 9.44 12.573 7.731 14.29 7.344Z"
          fill="#0041D9"
        />
        <path
          d="M5.915 20.835a.77.77 0 0 1-.889-.214 86.356 86.356 0 0 1-1.272-1.565.778.778 0 0 1 .02-.992c1.221-1.41 4.872-5.362 6.55-6.478.037-.024.027-.048-.014-.038-2.057.555-8.022 2.766-10.31 3.888v6.72c0 .832.672 1.504 1.505 1.504H19.5c.83 0 1.505-.672 1.505-1.502v-5.422c-3.065.433-11.066 2.415-15.09 4.102v-.003Z"
          fill="#0041D9"
        />
      </g>
    </svg>
  );
};
